/* BaristaYOU – Conversion Next */
(function () {
  'use strict';
  if (window.__byConversionNextInit) return;
  window.__byConversionNextInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var cartState = { cart: null, ids: {}, loaded: false };
  var cartPromise = null;
  var cartTimer = null;
  var productMeta = null;
  var productIdentity = null;
  var stickyImpressionSent = false;

  function normalize(value) {
    return String(value || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function safeJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function track(name, data) {
    var payload = data || {};
    var eventPayload = { event: name, by_source: 'baristayou_theme' };
    Object.keys(payload).forEach(function (key) { eventPayload[key] = payload[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    try {
      document.dispatchEvent(new CustomEvent('by:conversion-event', { detail: eventPayload }));
    } catch (e) {}
  }

  function updateCartState(cart) {
    cartState.cart = cart || { items: [] };
    cartState.ids = {};
    (cartState.cart.items || []).forEach(function (item) {
      var id = String(item.variant_id || item.id || '');
      if (id) cartState.ids[id] = (cartState.ids[id] || 0) + Number(item.quantity || 1);
    });
    cartState.loaded = true;
    syncUpsellButtons();
    syncPdpProgress();
    return cartState.cart;
  }

  function loadCart(force) {
    if (cartPromise && !force) return cartPromise;
    cartPromise = fetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return response.json();
    }).then(updateCartState).catch(function () {
      return cartState.cart;
    }).finally(function () {
      cartPromise = null;
    });
    return cartPromise;
  }

  function scheduleCartReload() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () { loadCart(true); }, 180);
  }

  /* ---------- Cart-aware upsell cards ---------- */
  function isRepeatableUpsell(button) {
    var card = button.closest('.up-card');
    var cardText = card ? normalize((card.getAttribute('data-by-product-type') || '') + ' ' + (card.getAttribute('data-by-product-title') || '')) : '';
    if (hasAny(cardText, ['kaffee', 'bohnen', 'roestung', 'coffee beans'])) return true;

    var panel = button.closest('.up-panel');
    if (!panel) return false;
    var tabId = panel.getAttribute('aria-labelledby');
    var tab = tabId ? document.getElementById(tabId) : null;
    var text = normalize(tab ? tab.textContent : '');
    return text.indexOf('bohnen') !== -1 || text.indexOf('roestung') !== -1 || text.indexOf('kaffee') !== -1;
  }

  function setUpsellButtonState(button) {
    if (!button || !button.hasAttribute('data-by-quick-add')) return;
    if (button.classList.contains('is-loading')) return;
    var id = String(button.getAttribute('data-variant-id') || '');
    if (!id) return;
    var inCart = !!cartState.ids[id];
    var label = button.dataset.byOriginalSetupLabel || '+ Zum Setup hinzufügen';
    if (!button.dataset.byOriginalSetupLabel) button.dataset.byOriginalSetupLabel = label;
    var card = button.closest('.up-card');
    var repeatable = isRepeatableUpsell(button);

    if (inCart && repeatable) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-in-cart');
      button.classList.add('is-repeatable-in-cart');
      if (button.textContent.trim() !== '+ Noch eins') button.textContent = '+ Noch eins';
      if (card) {
        card.classList.remove('up-card--in-cart');
        card.classList.add('up-card--repeatable');
      }
    } else if (inCart) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.remove('is-repeatable-in-cart');
      button.classList.add('is-in-cart');
      if (button.textContent.trim() !== 'Im Setup ✓') button.textContent = 'Im Setup ✓';
      if (card) {
        card.classList.remove('up-card--repeatable');
        card.classList.add('up-card--in-cart');
      }
    } else {
      var wasManaged = button.classList.contains('is-in-cart') || button.classList.contains('is-repeatable-in-cart');
      button.classList.remove('is-in-cart', 'is-repeatable-in-cart');
      if (card) card.classList.remove('up-card--in-cart', 'up-card--repeatable');
      if (wasManaged) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.textContent = label;
      }
    }
  }

  function syncUpsellButtons() {
    document.querySelectorAll('[data-section-type="upsell-tabs"] [data-by-quick-add]').forEach(setUpsellButtonState);
  }

  function initUpsellAwareness() {
    var sections = document.querySelectorAll('[data-section-type="upsell-tabs"]');
    if (!sections.length) return;
    sections.forEach(function (section) {
      if (section.dataset.byCartAware === 'true') return;
      section.dataset.byCartAware = 'true';
      if (window.MutationObserver) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            syncUpsellButtons();
          });
        }).observe(section, { childList: true, subtree: true, characterData: true });
      }
    });
    loadCart(false).then(syncUpsellButtons);
  }

  /* ---------- PDP setup progress ---------- */
  function cartItemText(item) {
    return normalize([item.product_type, item.title, item.vendor, item.handle].filter(Boolean).join(' '));
  }
  function hasAny(text, list) {
    return list.some(function (term) { return text.indexOf(term) !== -1; });
  }
  function cartHasKind(kind) {
    var items = (cartState.cart && cartState.cart.items) || [];
    return items.some(function (item) {
      var t = cartItemText(item);
      if (kind === 'grinder') return hasAny(t, ['kaffeemuehle','espressomuehle','muehle','grinder','mahlkoenig','eureka','mazzer','comandante','varia vs','exacto','twist','libra','specialita','x64','ek43','e65','e80']);
      if (kind === 'coffee') return hasAny(t, ['kaffeebohnen','espresso roestung','filter roestung','coffee beans']);
      if (kind === 'care') return hasAny(t, ['pflege set','pflegeset','reiniger','reinigung','entkalker','cleaner','backflush']);
      if (kind === 'scale') return hasAny(t, ['kaffeewaage','waage','scale','acaia','aku mini','aku pro']);
      return false;
    });
  }

  function getPdpSetupDefinition() {
    productMeta = productMeta || safeJson('by-conversion-product-meta');
    if (!productMeta) return null;
    var type = normalize(productMeta.productType);
    if (hasAny(type, ['filterkaffeemaschine'])) {
      return [{ key: 'current', label: 'Filter' }, { key: 'grinder', label: 'Mühle' }, { key: 'coffee', label: 'Bohnen' }, { key: 'scale', label: 'Waage' }];
    }
    if (hasAny(type, ['espressomaschine bundle','bundle'])) {
      return [{ key: 'current', label: 'Bundle' }, { key: 'coffee', label: 'Bohnen' }, { key: 'care', label: 'Pflege' }];
    }
    if (hasAny(type, ['espressomaschine','siebtraegermaschine'])) {
      return [{ key: 'current', label: 'Maschine' }, { key: 'grinder', label: 'Mühle' }, { key: 'coffee', label: 'Bohnen' }, { key: 'care', label: 'Pflege' }];
    }
    if (hasAny(type, ['kaffeemuehle','espressomuehle','muehle','grinder'])) {
      return [{ key: 'current', label: 'Mühle' }, { key: 'coffee', label: 'Bohnen' }, { key: 'scale', label: 'Waage' }];
    }
    return null;
  }

  function setupRecommendation(step) {
    var type = normalize((productMeta || {}).productType);
    var filter = type.indexOf('filterkaffeemaschine') !== -1;
    var paths = {
      grinder: filter ? 'filterkaffee-muhlen' : 'alle-kaffeemuhlen-fur-espresso-filterkaffee',
      coffee: filter ? 'filter-rostungen' : (type.indexOf('muehle') !== -1 ? 'kaffeebohnen' : 'espresso-rostungen'),
      care: 'pflege-sets-fur-siebtragermaschinen',
      scale: 'kaffeewaagen'
    };
    var titles = { grinder: 'Mühle auswählen', coffee: 'Bohnen entdecken', care: 'Pflege ergänzen', scale: 'Waage auswählen' };
    var reasons = { grinder: filter ? 'Den Mahlgrad auf deinen Filterkaffee abstimmen.' : 'Frisch mahlen und den Espresso gezielt einstellen.', coffee: 'Finde die Röstung für deinen Geschmack.', care: 'Deine Maschine reinigen und dauerhaft pflegen.', scale: 'Kaffee und Wasser präzise dosieren.' };
    return { url: ROOT + 'collections/' + paths[step.key], title: titles[step.key], reason: reasons[step.key] };
  }

  function initPdpProgress() {
    if (document.querySelector('.by-pdp-post-cta') && document.querySelector('[data-section-type="upsell-tabs"]')) return;
    if (document.querySelector('[data-by-pdp-setup-progress]')) return;
    var info = document.querySelector('product-info[data-product-handle]');
    var buttons = info && info.querySelector('.product__block--buttons');
    var def = getPdpSetupDefinition();
    if (!info || !buttons || !def) return;
    var block = document.createElement('section');
    block.className = 'by-pdp-setup-progress by-setup-advisor';
    block.setAttribute('data-by-pdp-setup-progress', '');
    block.setAttribute('aria-label', 'Dein Setup sinnvoll ergänzen');
    var heading = document.createElement('h3');
    heading.className = 'by-setup-advisor__heading';
    heading.textContent = 'Dein Setup sinnvoll ergänzen';
    var intro = document.createElement('p');
    intro.className = 'by-setup-advisor__intro';
    intro.textContent = 'Schon ausgestattet? Dann wähle nur, was dir noch fehlt. Alle Ergänzungen sind optional.';
    var list = document.createElement('div');
    list.className = 'by-setup-advisor__links';
    def.filter(function(step) { return step.key !== 'current'; }).forEach(function(step) {
      var rec = setupRecommendation(step);
      var link = document.createElement('a');
      link.className = 'by-setup-advisor__link';
      link.href = rec.url;
      link.setAttribute('data-stage-key', step.key);
      var title = document.createElement('strong');
      title.textContent = rec.title;
      var reason = document.createElement('span');
      reason.className = 'by-setup-advisor__reason';
      reason.textContent = rec.reason;
      var action = document.createElement('span');
      action.className = 'by-setup-advisor__action';
      action.textContent = 'Entdecken →';
      var status = document.createElement('span');
      status.className = 'by-setup-advisor__status';
      status.hidden = true;
      status.textContent = 'Aus dieser Kategorie im Warenkorb';
      link.append(title, reason, action, status);
      list.appendChild(link);
    });
    block.append(heading, intro, list);
    var accordions = info.querySelectorAll('.product__block--accordion');
    var details = accordions.length ? accordions[accordions.length - 1] : (info.querySelector('[data-by-decision-highlights]') || info.querySelector('.by-buy-confidence__grid'));
    (details || buttons).insertAdjacentElement('afterend', block);
    track('by_pdp_setup_guide_view', { by_product_type: productMeta.productType || '' });
    loadCart(false).then(syncPdpProgress);
  }

  function syncPdpProgress() {
    var block = document.querySelector('[data-by-pdp-setup-progress]');
    if (!block) return;
    block.querySelectorAll('[data-stage-key]').forEach(function(stage) {
      var done = cartState.loaded && cartHasKind(stage.getAttribute('data-stage-key'));
      stage.classList.toggle('is-done', !!done);
      var status = stage.querySelector('.by-setup-advisor__status');
      if (status) status.hidden = !done;
    });
  }

  /* ---------- Mobile native-CTA proxy ---------- */
  function initMobileBuyBar() {
    var info = document.querySelector('product-info[data-product-handle]');
    if (!info || document.querySelector('[data-by-mobile-buy-bar]')) return;
    productIdentity = productIdentity || safeJson('by-wishlist-product-data') || {};
    productMeta = productMeta || safeJson('by-conversion-product-meta') || {};
    var bar = document.createElement('div');
    bar.className = 'by-mobile-buy-bar';
    bar.setAttribute('data-by-mobile-buy-bar', '');
    bar.innerHTML = '<div class="by-mobile-buy-bar__copy"><strong class="by-mobile-buy-bar__title"></strong><span class="by-mobile-buy-bar__meta"><span data-by-mobile-variant></span><span class="by-mobile-buy-bar__price" data-by-mobile-price></span></span></div><button type="button" class="by-mobile-buy-bar__button" data-by-mobile-buy-button>In den Warenkorb</button>';
    document.body.appendChild(bar);

    var title = bar.querySelector('.by-mobile-buy-bar__title');
    var variant = bar.querySelector('[data-by-mobile-variant]');
    var price = bar.querySelector('[data-by-mobile-price]');
    var proxy = bar.querySelector('[data-by-mobile-buy-button]');
    if (title) title.textContent = productIdentity.title || document.title;
    var productData = { variants: Array.isArray(productMeta.variants) ? productMeta.variants : [] };
    var syncTimer = null;

    function mainButton() { return info.querySelector('[data-add-to-cart]'); }
    function buyBlock() { return info.querySelector('.product__block--buttons'); }
    function currentVariantId() {
      var input = info.querySelector('form[data-product-form] [name="id"], .product-variant-id');
      return input ? String(input.value || '') : '';
    }
    function visiblePrice() {
      var p = info.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price-item--regular, [data-product-price]');
      return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function drawerOpen() {
      var d = document.querySelector('cart-drawer');
      if (!d) return false;
      return d.classList.contains('is-open') || d.classList.contains('is-visible') || d.getAttribute('aria-hidden') === 'false';
    }
    function variantTitle() {
      if (!productData || !Array.isArray(productData.variants)) return '';
      var id = currentVariantId();
      var v = productData.variants.find(function (x) { return String(x.id) === id; });
      if (!v || !v.title || v.title === 'Default Title') return '';
      return v.title;
    }
    function syncCopy() {
      var nativeButton = mainButton();
      if (!nativeButton) return;
      var nativeText = nativeButton.querySelector('[data-add-to-cart-text]');
      var buttonText = nativeText ? nativeText.textContent.trim() : nativeButton.textContent.trim();
      proxy.textContent = buttonText || 'In den Warenkorb';
      proxy.disabled = !!nativeButton.disabled;
      var vTitle = variantTitle();
      var pText = visiblePrice();
      if (variant) variant.textContent = vTitle ? (vTitle + (pText ? ' · ' : '')) : '';
      if (price) price.textContent = pText;
    }
    function syncVisibility() {
      var block = buyBlock();
      if (!block || window.innerWidth > 749 || drawerOpen()) {
        bar.classList.remove('is-visible');
        return;
      }
      var rect = block.getBoundingClientRect();
      var show = rect.bottom < 0 && window.scrollY > 320;
      bar.classList.toggle('is-visible', show);
      if (show && !stickyImpressionSent) {
        stickyImpressionSent = true;
        track('by_mobile_sticky_atc_view', { by_product: productIdentity.handle || '' });
      }
    }
    function syncAll() { syncCopy(); syncVisibility(); }
    function scheduleSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncAll, 50);
    }

    proxy.addEventListener('click', function () {
      var nativeButton = mainButton();
      if (!nativeButton || nativeButton.disabled) return;
      track('by_mobile_sticky_atc_click', {
        by_product: productIdentity.handle || '',
        by_variant_id: currentVariantId(),
        by_price_text: visiblePrice()
      });
      bar.classList.add('is-pressed');
      setTimeout(function () { bar.classList.remove('is-pressed'); }, 120);
      nativeButton.click();
    });

    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    info.addEventListener('change', scheduleSync);
    if (window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','value','class'] });
      var drawer = document.querySelector('cart-drawer');
      if (drawer) new MutationObserver(syncVisibility).observe(drawer, { attributes: true, attributeFilter: ['class','aria-hidden'] });
    }

    syncAll();
  }

  /* ---------- Event layer ---------- */
  function initEventTracking() {
    document.addEventListener('click', function (event) {
      var setupLink = event.target.closest && event.target.closest('.by-setup-check__link');
      if (setupLink) track('by_cart_setup_recommendation_click', { by_label: setupLink.textContent.replace(/\s+/g, ' ').trim(), by_href: setupLink.getAttribute('href') || '' });
      var checkout = event.target.closest && event.target.closest('.cart__checkout');
      if (checkout) track('by_checkout_click', { by_location: checkout.closest('cart-drawer') ? 'drawer' : 'cart_page' });
      var tab = event.target.closest && event.target.closest('[data-section-type="upsell-tabs"] .up-tab');
      if (tab) track('by_upsell_tab_select', { by_tab: tab.textContent.replace(/\s+/g, ' ').trim() });
    });

    document.addEventListener('by:upsell:add', function (event) {
      var detail = (event && event.detail) || {};
      var id = String(detail.variantId || '');
      if (id && !cartState.ids[id]) cartState.ids[id] = 1;
      syncUpsellButtons();
      track('by_upsell_quick_add_success', {
        by_variant_id: id,
        by_product_title: detail.productTitle || ''
      });
    });

    document.addEventListener('theme:cart:change', function (event) {
      var cart = event && event.detail && event.detail.cart;
      if (cart && Array.isArray(cart.items)) updateCartState(cart);
      else scheduleCartReload();
    });
    ['theme:cart:refresh', 'theme:product:added'].forEach(function (name) {
      document.addEventListener(name, scheduleCartReload);
    });
  }

  function initProductFeatures() {
    initUpsellAwareness();
    initPdpProgress();
    initMobileBuyBar();
  }

  initEventTracking();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductFeatures();
      loadCart(false);
    });
  } else {
    initProductFeatures();
    loadCart(false);
  }
  document.addEventListener('shopify:section:load', function () {
    initProductFeatures();
    setTimeout(syncUpsellButtons, 120);
  });
})();

